import { CheckRounded, ExpandLessRounded, ExpandMoreRounded } from '@mui/icons-material';
import {
  MenuItem,
  Typography,
} from '@mui/material';
import React from 'react';
import useProjectInfoContext from '../../../../../../../../../Contexts/ProjectContexts/ProjectInfoContext/useProjectInfoContext';
import { StyledButton, StyledMenu } from './styles';

interface ProjectSelectorProps {
  disabledProjectChange: boolean;
  setSelectedProject: React.Dispatch<React.SetStateAction<{
    id: string;
    name: string;
  }>>;
  selectedProject: { id: string, name: string };
}

export default function ProjectSelector(props: ProjectSelectorProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const { projects, project } = useProjectInfoContext();
  const { disabledProjectChange, setSelectedProject, selectedProject } = props;

  if (disabledProjectChange) {
    return (
      <Typography variant="body1">
        {selectedProject.name}
      </Typography>
    );
  } return (
    <>
      <StyledButton
        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          if (anchorEl) {
            setAnchorEl(null);
          } else {
            setAnchorEl(event.currentTarget);
          }
        }}
      >
        {selectedProject.name}
        {anchorEl ? <ExpandLessRounded /> : <ExpandMoreRounded />}
      </StyledButton>
      <StyledMenu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => { setAnchorEl(null); }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        {projects.map((item) => (
          <MenuItem key={item.id} onClick={() => { setSelectedProject(item); }}>
            {project === item && <CheckRounded />}
            {item.name}
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  );
}
